import {ICountryPriceLocaleSettings} from 'coreStore/data/configurations/types';
import {EPriceType} from './IMoney';

const DEFAULT_LOCALE = 'en-US'; // Default locale to display correct currency format

export interface IFormattedMoney {
	countryPriceConfig: ICountryPriceLocaleSettings;
	value: number;
	currency: string;
	options: Intl.NumberFormatOptions;
	spaceBetweenCurrencyAndPrice: boolean;
	countryCurrencySymbol?: string;
	priceType?: EPriceType;
	locale: string;
}

export const formattedMoney = ({
	countryPriceConfig,
	value,
	currency,
	options,
	spaceBetweenCurrencyAndPrice,
	countryCurrencySymbol,
	priceType,
	locale = DEFAULT_LOCALE
}: IFormattedMoney) => {
	let priceResult = '';
	let currencySign = '';
	let decimalSeparator = '.';
	let thousandSeparator = countryPriceConfig.thousandSeparator || '.';

	const currencyFirst = countryPriceConfig.currencyFirst || false;

	const parts = Intl.NumberFormat(locale, {
		style: 'currency',
		currency,
		currencyDisplay: 'symbol',
		...options,
	}).formatToParts(value);

	parts.forEach((part) => {
		switch (part.type) {
			case 'group':
				thousandSeparator = part.value;
				priceResult += thousandSeparator || ',';

				break;
			case 'currency':
				//Intl.NumberFormat doesn't recognize as currency SGD if the country passed is not SG
				//when country is SG it replaces with "$" and not "S$"
				//when country is CN it replaces with "¥" and not "€"
				//when country is KR it replaces with "₩" and not "€"
				//https://github.com/andyearnshaw/Intl.js/issues/276
				if (part.value === 'SGD') {
					currencySign = 'S$';
				} else if (part.value === 'CN¥') {
					currencySign = '¥';
				} else if (part.value === '₩') {
					currencySign = '₩';
				} else if (part.value === 'AED') {
					currencySign = 'د.إ';
				} else if (part.value === 'SAR') {
					currencySign = '﷼';
				} else if (part.value === 'QAR') {
					currencySign = 'ر.ق';
				} else if (part.value === 'BHD') {
					currencySign = 'د.ب';
				} else if (part.value === 'KWD') {
					currencySign = 'د.ك';
				} else {
					currencySign = part.value || countryCurrencySymbol;
				}

				break;
			case 'decimal':
				decimalSeparator = part.value;

				break;
			case 'fraction':
				if (priceType === EPriceType.PRICE_LONG) {
					priceResult = `${priceResult}${decimalSeparator}${part.value}`;
				}

				if (priceType === EPriceType.PRICE_SHORT) {
					if (part.value !== '00' && part.value !== '000') {
						priceResult = `${priceResult}.${part.value}`;
					}
				}

				break;

			default:
				priceResult += part.value;
		}
	});

	if (currencyFirst) {
		priceResult = currencySign + (spaceBetweenCurrencyAndPrice ? ' ' : '') + priceResult;
	} else {
		priceResult = priceResult + (spaceBetweenCurrencyAndPrice ? ' ' : '') + currencySign;
	}

	return priceResult;
};
